import {CommonMessages} from '../common.messages';

export const PanelAccountsUseMessages = {
    GetTradingClientFailed: {
        key: 'GetTradingClientFailed',
        message: 'Error while communication with the server. Unable to get available trading details.'
    },
    TradingClientNotFound: {
        key: 'TradingClientNotFound',
        message: 'Error while communication with the server. Unable to find available trading details.'
    },
    CashAccountsNotFound: {
        key: 'CashAccountsNotFound',
        message: 'Error while communication with the server. Unable to find available active cash accounts.'
    },
    GetClientFailed: {
        key: 'GetClientFailed',
        message: 'Error while communication with the server. Unable to get client.'
    },
    GetClientNotFound: {
        key: 'GetClientNotFound',
        message: 'Error while communication with the server. Unable to find client.'
    },
    UpdateCollectRebatesFailed: {
        key: 'UpdateCollectRebatesFailed',
        message: 'Error while communication with the server. Unable to update Collect Rebates In.'
    },
    ...CommonMessages
};
